<template>
  <div v-if="sliderContents.length > 0" class="slider">
    <hooper
      :settings="hooperSettings"
      :infiniteScroll="infiniteScroll"
      :autoPlay="autoPlay"
      :playSpeed="autoPlaySpeed"
      >
      <slide v-for="(val, index) in sliderContents" :key="index">
        <router-link :to="{ name: 'ColumnSingle', params: { articleId: val.articleId } }">
          <div class="slider_image" :style="{'background-image': 'url('+ setImagePath(val.thumbnailImagePath) +')'}"></div>
        </router-link>
      </slide>
    <hooper-pagination slot="hooper-addons"></hooper-pagination>
    </hooper>
  </div>
</template>

<script>
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
} from 'hooper';
import 'hooper/dist/hooper.css';
import TagList from '@/components/api/fanClub/article';
import Config from '@/config/config';

export default {
  components: {
    Hooper,
    Slide,
    HooperPagination,
  },
  data() {
    return {
      hooperSettings: {
        itemsToShow: 1,
        centerMode: true
      },
      infiniteScroll: true,
      autoPlay: true,
      autoPlaySpeed: 5000,
      sliderContents: [],
      imagePath: Config.APIURL,
      noImagePath: require('../../../assets/images/dummy1.jpg'),
    }
  },
  methods: {
    setImagePath(image) {
      if(image != null) {
        return this.imagePath + image;
      } else {
        return this.noImagePath;
      }

      // val.thumbnailImagePath
    },
    prev() {
      if(this.showNumber <= 0){
        return;
      }
      this.showNumber --;
    },
    next() {
      if(this.showNumber + 1 >= this.images.length){
        this.showNumber = 0
        return;
      }
      this.showNumber ++;
    },
    Selectdots(n) {
      this.showNumber = n
    },
    async apiGetTopicsList() {
      await TagList.getTopicsList().then((val) => {
        console.log('スライダー');
        console.log(val);
        this.sliderContents.push(...val);
      });
    },
  },
  created() {
    this.apiGetTopicsList();
  }
}
</script>

<style lang="css" scoped>
.slider_image {
  background-position: center;
  background-size: cover;
  height: 188px;
  width: 100%;
}

.dots {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.dots_button {
  border: none;
  background-color: #ccc;
  border-radius: 50%;
  display: block;
  height: 9px;
  margin: 0 5px;
  padding: 0;
  width: 9px;
}
.dots_button.current {
  background-color: #DF0068;
}
>>> .hooper-pagination {
  bottom: -8px;
  padding: 0;
}
>>> .hooper-indicator {
  border: none;
  background-color: #ccc;
  border-radius: 50%;
  height: 9px;
  margin: 0 5px;
  padding: 0;
  width: 9px;
}
>>> .hooper-indicator.is-active {
  background-color: #DF0068;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/column/Slider.vue